import { z } from 'zod'

/**
 * Cross-tool AI Studio primitives. Tool-specific request/response contracts
 * live in their own `ai-studio-<tool>.ts` file (e.g. `ai-studio-event.ts`).
 */

export const styleAccentSchema = z.discriminatedUnion('mode', [
  z.object({ mode: z.literal('none') }),
  z.object({ mode: z.literal('single'), color: z.string() }),
  z.object({ mode: z.literal('palette'), colors: z.array(z.string()).min(2).max(4) }),
  z.object({
    mode: z.literal('gradient'),
    from: z.string(),
    to: z.string(),
    direction: z.enum(['tr', 'br', 'bl', 'tl']),
  }),
])

export type StyleAccent = z.infer<typeof styleAccentSchema>

export const brandColorsSchema = z.object({
  primaryColor: z.string().optional(),
  secondaryColor: z.string().optional(),
  accentColor: z.string().optional(),
})

export type BrandColors = z.infer<typeof brandColorsSchema>
